import Color from '../Color/Color'
import Header from '../Header/Header'
import classes from './MultiselectDropdown.module.scss'
import { HiOutlineSearch } from 'react-icons/hi'

const NoSearchResultFound = () =>
  <div className={classes.NoSearchResult}>
    <Color variant='stateGray'>
      <HiOutlineSearch
        aria-hidden
        size={24}
      />
    </Color>
    <Header
      hasNoTopMargin
      rank={4}
    >
      No results found
    </Header>
  </div>

export default NoSearchResultFound
